import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoggingApiService } from '../services/logging-api.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { LoggingMessageService } from '../services/logging-message.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private subscriptionKey: string;


    constructor(private http: HttpClient,
                private authService: AuthService,
                private msgLogger: LoggingMessageService,
                private logger: LoggingApiService) {
        this.subscriptionKey = environment.SubscriptionSelected;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const availableSubs = this.authService.AvailableSubscriptionsString;
        if ((availableSubs === '') || (availableSubs === null) || (availableSubs === undefined)) {
            const available = sessionStorage.getItem(environment.TokenSubscriptionsAvailable);
            this.authService.AvailableSubscriptionsString = available;
        }


        const subscription = this.getSubscription(availableSubs);
        const sub = +subscription;
        this.msgLogger.debug('token.interceptor', 'intercept', sub, availableSubs, 'Token Intercept running', '');
        this.msgLogger.debug('token.interceptor', 'intercept',  sub, availableSubs,'Adding token to header', '');

        const useCookies = environment.UseCookies;  //true for prod and uat otherwise false
        const isLoggedIn = this.authService.isUserLoggedIn();
        const cookiesEnabled = (useCookies && (useCookies === true));     
        const fedtoken = req.url.toLowerCase().includes('federationtoken') || req.url.toLowerCase().includes('exportuserstouam');

        this.msgLogger.debug('token.interceptor', 'intercept',  sub, availableSubs,`isLoggedIn:${isLoggedIn}`, '');

        console.log('cookiesEnabled should be true only for prod and uat. Current cookiesEnabled value: ', cookiesEnabled);

        let token = '';

        this.msgLogger.info('token.interceptor', 'intercept', sub, availableSubs, 'token interceptor running', `URL: ${req.url}`);

    // Handle FederationToken separately
      if (fedtoken) {
        this.msgLogger.info('token.interceptor', 'intercept', sub, availableSubs, 'Federation token request detected', `URL: ${req.url}`);
            
        token = this.authService.getFederationToken();
        if (!token) {
                this.msgLogger.warn('token.interceptor', 'intercept', sub, availableSubs, 'No federation token available for request', `URL: ${req.url}`);
            } else {
                this.msgLogger.info('token.interceptor', 'intercept', sub, availableSubs, 'Federation token found and will be used', `URL: ${req.url}`);
            }

        req = this.addToHeader(req, token, subscription, availableSubs);        
        //console.log('this is the token from the interceptor added to the header from getFederationToken()', token);
        } else if (!cookiesEnabled && isLoggedIn) {     
            token = this.authService.getAccessToken();
            if (JSON.stringify(token) === "{}") { token = ''; }
            req = this.addToHeader(req, token, subscription, availableSubs);
            //console.log('this is the token from the interceptor added to the header from getAccessToken()', token);
        }

        if (cookiesEnabled && isLoggedIn) {
            req = this.addSubscriptionToHeader(req, subscription, availableSubs);
        } 
        return next.handle(req);
    }

    private addToHeader(req: HttpRequest<any>, token: any, subscription: string, availableSubs: string): HttpRequest<any> {
        req = req.clone({
            withCredentials: true,
            setHeaders: {
                Authorization: token,
               'subscription': subscription
            }
        });
       
        this.msgLogger.debug('token.interceptor', 'addToHeader', +subscription, availableSubs,`Added Token and subscription:${subscription}`, '');
        return req;
    }

    private addSubscriptionToHeader(req: HttpRequest<any>, subscription: string, availableSubs: string): HttpRequest<any> {
        req = req.clone({
            setHeaders: {
                'subscription': subscription
            }
        });
        this.msgLogger.debug('token.interceptor', 'addSubscriptionToHeader',  +subscription, availableSubs,`Added subscription:${subscription}`, '');
        return req;
    }

    private postWindowMessage() {
        setTimeout(() => {
            this.msgLogger.warn('token.interceptor', 'postWindowMessage', this.authService.SelectedSubscription , this.authService.AvailableSubscriptionsString, 'Indicator Factory posting logout message', '');
            window.parent.postMessage('logout:', '*');
        }, 0);
    }

    private getSubscription(availableSubs: string): string {
        // this.msgLogger.info('token.interceptor', 'getSubscription',  +this.authService.getSubscription(), this.authService.getSubscriptionsAvailable(),`subscription key:${this.subscriptionKey}`, '');
        let subid = sessionStorage.getItem(this.subscriptionKey);
        this.msgLogger.debug('token.interceptor', 'getSubscription', +subid, availableSubs, `got subscription:${subid}`, '');
        subid = (subid) ? subid : '';
        if ((environment.environment == 'Local') && (subid === '')) {
            subid = environment.SubscriptionSelectedLocalTest;
            sessionStorage.setItem(this.subscriptionKey, subid);
            this.authService.SelectedSubscription = +subid;
        }
        return subid;
    }
}
